import { useState } from 'react';
import { auth, db } from '../firebase/config';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useAuthContext } from './useAuthContext';

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useAuthContext();

  const signup = async (email, password, displayName) => {
    setIsLoading(true);
    setError(null);

    try {
      // Create user with email and password
      const res = await createUserWithEmailAndPassword(auth, email, password);

      if (!res.user) {
        throw new Error('Could not complete signup');
      }

      // Add display name to user
      await updateProfile(res.user, { displayName });

      // Create a user document in Firestore
      await setDoc(doc(db, 'users', res.user.uid), {
        uid: res.user.uid,
        displayName,
        email,
        role: 'user', // Default role for all new signups
        createdAt: new Date(),
      });

      // Dispatch login action
      dispatch({ type: 'LOGIN', payload: res.user });

      setIsLoading(false);
    } catch (err) {
      console.error(err.message);
      setError(err.message);
      setIsLoading(false);
    }
  };

  return { signup, isLoading, error };
};
